<template>
  <div class="user-info-panel-glass">
    <!-- User Profile Section -->
    <div class="user-profile" @click="$router.push('/userInfo')">
      <div class="avatar-wrapper">
        <el-avatar :size="64" :src="userInfo.avatar || defaultAvatar" class="premium-avatar" />
      </div>
      <div class="greeting">
        <p class="welcome">Hey, {{ userInfo.nickname || 'Explorer' }}</p>
        <div class="status-tags">
          <span class="tag gold">Elite Member</span>
        </div>
      </div>
    </div>

    <!-- Quick Stats -->
    <div class="stats-glass-grid">
      <div class="stat-item cur-poi" @click="$router.push('/coupons')">
        <span class="value">{{ userInfo.couponCount || 0 }}</span>
        <span class="label">Coupons</span>
      </div>
      <div class="stat-item cur-poi" @click="$router.push('/favorites')">
        <span class="value">{{ userInfo.collectCount || 0 }}</span>
        <span class="label">Saved</span>
      </div>
      <div class="stat-item">
        <span class="value">{{ userInfo.integral || 0 }}</span>
        <span class="label">Points</span>
      </div>
    </div>

    <!-- Actions -->
    <div class="action-buttons">
      <el-button type="primary" round class="premium-btn" @click="$store.commit('setLoginVisible', true)" v-if="!isLogin">Join the Elite</el-button>
      <div class="member-actions" v-else>
        <button class="icon-action-btn" @click="$router.push('/myOrder')" title="Check Orders">
            <i class="el-icon-shopping-bag-2"></i>
            <span>Orders</span>
        </button>
        <button class="icon-action-btn" @click="$router.push('/favorites')" title="View Favorites">
            <i class="el-icon-magic-stick"></i>
            <span>Wishlist</span>
        </button>
      </div>
    </div>

  </div>
</template>

<script>
import { getUserInfo } from '@/api/login.js'
import { getToken } from '@/axios/cookies.js'

export default {
  name: 'UserInfoPanel',
  data() {
    return {
      defaultAvatar: 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png',
      userInfo: {},
      isLogin: false
    }
  },
  created() {
    this.checkLogin()
  },
  methods: {
    checkLogin() {
      const token = getToken()
      if (token) {
        this.isLogin = true
        this.fetchUserInfo()
      } else {
        this.isLogin = false
      }
    },
    async fetchUserInfo() {
      try {
        const res = await getUserInfo()
        if (res.status === 200) {
          this.userInfo = res.data
        }
      } catch (error) {
        console.error('Failed to fetch user info:', error)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";

.user-info-panel-glass {
  width: 100%;
  height: 100%;
  background: $glass-bg;
  backdrop-filter: $glass-blur;
  border: 1px solid $glass-border;
  border-radius: 20px;
  padding: 32px 24px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-shadow: $shadow-lg;

  .user-profile {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 16px;
    cursor: pointer;
    transition: $transition-fast;
    
    &:hover {
        transform: translateY(-4px);
        .avatar-wrapper {
            box-shadow: 0 12px 24px rgba($primary-color, 0.4);
        }
    }

    .avatar-wrapper {
      padding: 4px;
      background: linear-gradient(135deg, $primary-color, #ff9b9b);
      border-radius: 50%;
      box-shadow: 0 8px 16px rgba($primary-color, 0.2);
      .premium-avatar {
          border: 2px solid $white;
      }
    }

    .greeting {
      .welcome {
        font-size: 20px;
        font-weight: 800;
        color: $gray-900;
        margin-bottom: 6px;
      }
      .tag {
        font-size: 11px;
        padding: 4px 12px;
        border-radius: 20px;
        font-weight: 700;
        text-transform: uppercase;
        &.gold {
          background: #fff9db;
          color: #f08c00;
          box-shadow: 0 2px 8px rgba(#f08c00, 0.1);
        }
      }
    }
  }

  .stats-glass-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    background: rgba(255, 255, 255, 0.4);
    padding: 20px 10px;
    border-radius: 18px;
    border: 1px solid rgba(255, 255, 255, 0.6);
    
    .stat-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      &:not(:last-child) {
        border-right: 1px solid rgba(0, 0, 0, 0.05);
      }
      .value {
        font-weight: 800;
        font-size: 18px;
        color: $gray-900;
      }
      .label {
        font-size: 10px;
        color: $gray-500;
        margin-top: 4px;
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: 0.5px;
      }
    }
  }

  .action-buttons {
    .premium-btn {
      width: 100%;
      height: 48px;
      font-weight: 800;
      font-size: 14px;
      background: $primary-color;
      border: none;
      box-shadow: 0 8px 16px rgba($primary-color, 0.2);
      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 12px 24px rgba($primary-color, 0.3);
      }
    }

    .member-actions {
      display: flex;
      gap: 16px;
      
      .icon-action-btn {
          flex: 1;
          background: $white;
          border: 1px solid $gray-100;
          border-radius: 16px;
          padding: 12px 8px;
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 6px;
          cursor: pointer;
          transition: all 0.2s;
          
          i { font-size: 20px; color: $gray-400; }
          span { font-size: 10px; font-weight: 700; color: $gray-500; text-transform: uppercase; }
          
          &:hover {
              background: $primary-color;
              border-color: $primary-color;
              i, span { color: $white; }
              transform: translateY(-2px);
          }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/PageIndex/indexAll/components/UserInfoPanel.vue